import { AscFileType } from '../models/common-types';

export function getFileTypeFromExtension(location: string): AscFileType {
  const extension = location?.split('.')?.pop();
  if (extension) {
    switch (extension.toLowerCase()) {
      case 'pdf':
      case 'doc':
      case 'docx':
      case 'xlsx':
      case 'xls':
      case 'pptx':
      case 'ppt':
        return 'docs';
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
        return 'image';
      case 'mp4':
      case 'mov':
      case 'avi':
      case 'wmv':
      case 'flv':
      case 'webm':
        return 'video';
      default:
        return 'other';
    }
  }
  return 'other';
}
